import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/doc.png'


const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "choose-files"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["accept"]
const _hoisted_7 = {
  key: 2,
  class: "fs-xs text-grey text-center"
}
const _hoisted_8 = { class: "drag-drop-files" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "file-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['drag-drop', _ctx.customClasses]),
    ref: "dragDropArea",
    onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
    onDragleave: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"])),
    onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.files.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.icon)
          }, null, 2),
          (_ctx.text)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: "browse",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.text), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_5, [
                _createTextVNode(" Drag and Drop or "),
                _createElementVNode("span", {
                  class: "browse",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.browseText), 1)
              ])),
          _createElementVNode("input", {
            type: "file",
            accept: _ctx.accept,
            ref: "fileInput",
            style: {"display":"none"},
            multiple: "",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
          }, null, 40, _hoisted_6),
          (_ctx.accept !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Supported: " + _toDisplayString(_ctx.accept), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "file-preview"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: file.name,
            class: "file-image-preview",
            width: "95",
            height: "55"
          }, null, 8, _hoisted_9),
          _createElementVNode("small", _hoisted_10, _toDisplayString(file.name), 1)
        ]))
      }), 128))
    ])
  ], 34))
}